<template>
  <div id="app">
    <el-row class="container containbox">
      <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="one">
        <div class="menu">
          <div class="date">{{Detail.title}}</div>
          <div class="title"><span v-for="(item,i) in Type" :key="i">{{item}}<span v-if="i!=Type.length - 1"> | </span></span></div>
          <div class="line">
            <img src="../../static/img/dn-36.png">
          </div>
          <div class="detail Light">
            {{Detail.simple}}
          </div>
        </div>
      </el-col>
      <!-- 内容 -->
      <el-col :xs="0" :sm="2" :md="2" :lg="2" :xl="2" class="span">1</el-col>
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="two">
        <div v-html="Detail.content"></div>
        <!-- 分页 -->
        <div class="block" v-if="pageCount>0">
          <div class="left" @click="prev()" :class="{ 'disable':Detail.preId == null}">
            <div class="Light">Prev</div>
            <img src="../../static/img/dnx-86.png" class="promise-img">
          </div>
          <div class="middle" @click="all()">
            <img src="../../static/img/dn_ -37.png" class="promise-img">
          </div>
          <div class="right" @click="next()" :class="{ 'disable':Detail.nextId == null}">
            <div class="Light">Next</div>
            <img src="../../static/img/dnx-87.png" class="promise-img">
          </div>
        </div>
      </el-col>
      
    </el-row>
    <div class="container">
      <div class="title case">相关案例</div>
      <el-row>
        <div v-for="(item,index) in List" :key="index">
          <el-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8" class="scale-in d1" id="scale-in">
            <div class="box-card">
              <!-- <img src="../../static/img/dn-60.png" @click="$router.push('Business/MortgageLoan');" /> -->
              <div class="imgbox">
                <img :src="item.cover" class="card-img" id="box-card" :style="{ height: cardheight*0.83 + 'px' }" />
                <div class="overlay-box" :style="{ height: cardheight*0.83 + 'px' }" @click="CaseDetail(item.id)">
                  <div>{{item.title}}</div>
                  <div class="two Light">{{item.plates}}</div>
                </div>
              </div>
              <div class="m">{{item.title}}</div>
              <div class="sm Light">{{item.plates}}</div>
            </div>
          </el-col>
          <div class="clearfix visible-xs pc" v-if="(index+1) % 3 == 0 && index!==1"></div>
          <div class="clearfix visible-xs phone" v-if="(index+1) % 2 == 0 && index!==1"></div>
        </div>
      </el-row>
    </div>
    <SwiperBox></SwiperBox>
    <Call></Call>
  </div>
</template>

<script>
  import Call from "../components/CallUs";
  import SwiperBox from "../components/SwiperBox";
  import Swiper from 'swiper';
  export default {
    components: {
      Call,
      SwiperBox
    },
    data() {
      return {
        pageCount:1,
        currentPage:1,
        isActive:0,
        cardheight:0,
        List:[{
          cover:'../../static/img/dn-60.png'
        }],
        Type:[],
        Detail:[]
      }
    },
    mounted: function () {
      this.getInfo()
      this.getDetail()
      this.cardheight = document.querySelector('#scale-in').offsetWidth
      window.addEventListener('resize', () => 
        this.cardheight = document.querySelector('#scale-in').offsetWidth
      )
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollToTop)
      clearInterval(this.timer);
      this.timer = null;
    },
    deactivated() {
      this.$destroy()
    },
    watch:{   //监听路由变化
    $route( to , from ){   
        this.getInfo()
        this.getDetail()
        this.cardheight = document.getElementById('#scale-in').clientWidth* 0.83
      }
    },
    methods: {
      CaseDetail(id){
        // this.$router.push("/Case/id=" + id);
        // document.body.scrollTop = document.documentElement.scrollTop = 0;
        let routeData = this.$router.resolve({
          path: "/Case/id=" + id,
        });
        window.open(routeData.href, '_blank');
      },
      all(){
        this.$router.push("/Case");
      },
      next(){
        if(this.Detail.nextId == null){
          return
        }
        let routeData = this.$router.resolve({
          path: "/Case/id=" + this.Detail.nextId,
        });
        window.open(routeData.href, '_blank');
      },
      prev(){
        if(this.Detail.preId == null){
          return
        }
        let routeData = this.$router.resolve({
          path: "/Case/id=" + this.Detail.preId,
        });
        window.open(routeData.href, '_blank');
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getDetail(){
        this.$http
          .get("deno/api/case/info", {
            params:{
              id:window.location.href.split("id=")[1],
              plate:sessionStorage.getItem('plate'),
              business:sessionStorage.getItem('business')
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.Detail = response.data.data;
                this.Type = this.Detail.plates.split(",")
              }
            }.bind(this)
          )
      },
      getInfo() {
        let plate = ''
        let business = ''
        if(sessionStorage.getItem('plate') == ''){
          business = sessionStorage.getItem('business')
        }else{
          plate = sessionStorage.getItem('plate')
        }
        this.$http
          .get("deno/api/case/list", {
            params: {
              page:1,
              limit: 6,
              plate:plate,
              business:business
            }
          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.List = response.data.page.list;
              }
            }.bind(this)
          )
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.line  
  margin: 0 30px;
  margin-bottom: 10px;
  height: 1px;
  background-color: #ccc;
.containbox
  font-size 20px
  margin-top 60px
  .one
    line-height: 40px;
    margin-bottom: 30px;
    position relative
    .date
      font-size 20px
    .title
      font-size 20px
      margin-bottom 100px
    .type
      font-size: 16px;
    .line
      border-bottom 1px solid #ccc
      margin 30px 0
      position relative
      img 
        width 30px
        position: absolute;
        bottom: 1px;
        left: 0;
    .detail
      font-size: 16px;
  .span
    color raba(0,0,0,0)
    visibility hidden
  .two 
    img  
      max-width 100%
      width: 30px;
    .block
      text-align: center;
      margin-top: 30px;
      margin-bottom: 60px;
      color #333
      font-size 14px
      display flex
      justify-content space-between
      img
        width 20px
        cursor pointer
      .left.disable
        cursor: not-allowed;
      .left 
        cursor pointer
        position relative
        bottom: 0
        .Light
          position absolute
          right: 0
          top: -5px;
          font-size 14px
        img
          width 50px
      .right.disable
        cursor: not-allowed;
      .right
        cursor pointer
        position relative
        right: -7px;
        .Light
          left: 0;
          position absolute
          top: -5px;
          font-size 14px
        img
          width 50px
.container
  .title.case
    text-align center
    padding: 60px 0;
  .title
    font-size 50px
  .card-img
    width: 100%;
    height: 100%
    cursor: pointer;
.box-card
  font-size 16px
  .m
    margin-top 20px
  .sm
    font-size 14px
    margin: 20px 0 60px 0;
.imgbox
  padding: 0
  position relative
  cursor pointer
.imgbox:hover 
  opacity: 0.9;
  overflow hidden
  color: #fff;
.imgbox .overlay-box
  display none
.imgbox:hover .overlay-box
  flex-direction: column;
  cursor pointer
  bottom 0
  top 0
  background: rgba(255, 255, 255, 1);
  display block
  position: absolute;
  font-size: 16px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #000;
@media (max-width:768px) 
  .containbox .two .block img
    width 20px
  .containbox .two .block .left .Light,.containbox .two .block .right .Light
    font-size 12px
  .container .title
    font-size 25px
  .container .title.case
    padding 10px 0
  .containbox .two .block
    margin 30px 0
  .containbox .two .block .left
    left 0
  .containbox .two .block .right
    right 0
@media (min-width:1920px)
  .containbox .one .date
    font-size: 24px;
  .containbox .one .title,.containbox .one .detail
    font-size: 18px;
    line-height: 36px;
    margin: 36px 0 200px 0;
  .containbox .one .line img
    width 45px
  .box-card:hover .overlay-box
    font-size 26px
  .box-card:hover .overlay-box .two
    color #333
    margin-top 52px
    font-size 20px
  .box-card
    font-size: 20px;
  .box-card .m
    margin-top 20px
  .box-card .sm
    font-size: 18px;
    margin-bottom 60px
  .title case
    font-size: 50px;
  .line
    margin: 0 60px;
    margin-bottom: 20px;
  .containbox .two .block .left .Light,.containbox .two .block .right .Light
    font-size: 20px;
    top: -12px;
  .containbox .two .block .left img,.containbox .two .block .right img
    width 83px
  .containbox .two .block img
    width 40px
</style>


// WEBPACK FOOTER //
// src/components/CaseDetail.vue